export default "__VITE_ASSET__ClNBpMCW__"